import React, { useEffect, useState } from 'react';
import { dataForVSSubsTable } from 'shared/helpers/utils';
import { notification } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store';
import { RequestsSearch } from 'shared/types/types';
import { usePullSort } from 'shared/hooks';
import { RequestStatusType, SortCondition } from 'shared/enums';
import { SearchKeysNews } from 'shared/enums/news';
import { TVacationScheduleSubordinatePrepared } from 'shared/types/vacation-schedule.types';
import { TableVSSubs } from 'features/tables/tableVSSubs';
import { ColumnsType } from 'antd/lib/table';
import { useNavigate } from 'react-router-dom';
import { getVacationCheduleSupervisor } from 'entities/supervisor/vacationSchedule';
import { getCurrentDivision } from 'entities/divisions/model';
import { vacationsScheduleSupervisorApi } from 'app/services/edpApiV1/supervisor/vacationsSchedule';
import { TabKeys } from 'features/divisions';
import { TableRowSelection } from 'antd/lib/table/interface';
import {
  getMultiSelectedSubtitutionVacations,
  setVacations,
} from 'entities/vacationsSchedule/model/multiSelectSubtitution';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import style from './index.module.scss';

export const VacationsScheduleSubordinatesPull = () => {
  const [page, setCurrentPage] = useState<number>(1);
  const [size, setCurrentSize] = useState<number>(10);
  const [sortInfo, sortTrigger] = usePullSort();
  const sortOption = sortInfo.value && sortInfo.value === SortCondition.ASCEND ? SortCondition.ASC : SortCondition.DESC;
  const [search, setSearch] = useState<RequestsSearch>({ byId: undefined, fio: undefined });
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const multiVacations = useAppSelector(getMultiSelectedSubtitutionVacations);

  const { currentOption } = useAppSelector(getCurrentDivision);

  const [getVacationsScheduleDeputy] = vacationsScheduleSupervisorApi.useLazyVacationsScheduleDeputyQuery();
  const [getVacationsScheduleActing] = vacationsScheduleSupervisorApi.useLazyVacationsScheduleActingQuery();
  const [getVacationsScheduleSupervisor] = vacationsScheduleSupervisorApi.useLazyVacationsScheduleSupervisorQuery();

  const refetch = () => {
    if (!currentOption) {
      return;
    }
    try {
      switch (currentOption.type) {
        case TabKeys.ACTING:
          getVacationsScheduleActing({ page, size, divisionId: currentOption.value, ...search });
          break;
        case TabKeys.DEPUTY:
          getVacationsScheduleDeputy({ page, size, divisionId: currentOption.value, ...search });
          break;
        case TabKeys.SUPERVISOR:
          getVacationsScheduleSupervisor({ page, size, ...search });
          break;
      }
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  useEffect(() => {
    refetch();
  }, [currentOption, search, page, size]);

  const { data, pagination, loading } = useAppSelector(getVacationCheduleSupervisor);

  const onSelectChange = (_: React.Key[], selectedRows: TVacationScheduleSubordinatePrepared[]) => {
    const usersMap: Record<number, boolean> = {};
    //Убираем из выборки заявки, которые не нужно согласовывать
    const filteredArray = selectedRows.filter(elem => {
      const isOnSupervisorForRequest =
        (elem?.requests?.length || 0) > 0 &&
        elem.requests?.every(elem => elem.status.type === RequestStatusType.consideredBySupervisor);
      const isOnSupervisorForScheduledRequest =
        (elem?.scheduleRequests?.length || 0) > 0 &&
        elem.scheduleRequests?.every(elem => elem.status.type === RequestStatusType.consideredBySupervisor);

      const isOnSupervisor = isOnSupervisorForRequest || isOnSupervisorForScheduledRequest;
      if (isOnSupervisor) {
        return true;
      }
      return false;
    });

    // Выбираем, какие данные нужно добавить в выборку, а какие убрать
    for (const user of data) {
      usersMap[user.id] = false;
    }

    for (const row of filteredArray) {
      usersMap[row.id] = true;
    }

    // Добавляем и удаляем по результатам выборки данные в результирующий массив
    const usersToDelete = Object.keys(usersMap)
      .filter(elem => !usersMap[elem])
      .map(elem => Number(elem));
    const usersToAdd = Object.keys(usersMap)
      .filter(elem => usersMap[elem])
      .map(elem => Number(elem));
    const unionPickedData = [...usersToAdd, ...multiVacations.data];
    const unionDataWithDelete = unionPickedData.filter(elem => !usersToDelete.includes(elem));
    const uniquePickedData = Array.from(new Set(unionDataWithDelete));
    dispatch(setVacations(uniquePickedData));
  };

  const rowSelection: TableRowSelection<TVacationScheduleSubordinatePrepared> = {
    selectedRowKeys: multiVacations.data,
    onChange: onSelectChange,
  };

  const columns: ColumnsType<TVacationScheduleSubordinatePrepared> = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },

    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
  ];

  const onSearch = (data: string, key: SearchKeysNews) => {
    setSearch({ [key]: data ? data : undefined });
  };

  const onRowClick = (payload: TVacationScheduleSubordinatePrepared) => {
    const target = data.find(elem => elem.id === payload.id);
    if (!target) {
      return;
    }
    navigate(`/vacation-schedule-subordinates/user/${target.id}?page=${page}&size=${size}`);
  };

  return (
    <>
      {data && columns && (
        <TableVSSubs
          dataSource={dataForVSSubsTable(data)}
          columns={columns}
          currentPage={page}
          setCurrentPage={setCurrentPage}
          currentSize={size}
          setCurrentSize={setCurrentSize}
          total={pagination?.total}
          onSearch={onSearch}
          onRowClick={onRowClick}
          loading={loading}
          rowSelection={rowSelection}
        />
      )}
    </>
  );
};
